/* unplugin-vue-components disabled */
import InputFiles from './input-files.vue'
import InputText from './input-text.vue'
import $global from 'stores/global'
import {create_store} from 'stores/files'
import {DOCUMENT} from 'consts/ftypes.js'
import InputControls from './input-controls.vue'
import {computed} from 'vue'

const MAX_UPLOADS = 5

const __default__ = {
  components: {InputFiles, InputText, InputControls},
  mixins: [ModelValue(String)],
  provide() {
    return {
      di_recording: computed({
        get: () => this.recording,
        set: recording => this.recording = recording
      })
    }
  },
  props: {
    placeholder: {type: String, default: 'Ask..'},
    description: {type: String, default: ''},
    generating: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    controls: {type: Boolean, default: false},
    fade: {type: Boolean, default: false},
    shadow: {type: Boolean, default: false},
    uploadsEnabled: {type: Boolean, default: true},
  },
  emits: ['stop', 'regenerate'],
  data() {
    return {
      deep: false,
      focused: false,
      f_store: create_store(DOCUMENT.type),
      chat_height: 0,
      recording: false
    }
  },
  computed:{
    uploads_enabled() {
      // file uploading disabled in chat v1
      return false
    },
    chat_sharing_enabled() {
      return !this.chatSharingEnabled && $global.chatSharingEnabled && Boolean(this.chatId)
    },
    can_upload() {
      const files_len = this.f_store.files.length
      const uploads_len = this.f_store?.uploads.length
      return (files_len + uploads_len) < MAX_UPLOADS
    },
    can_push() {
      if (this.recording) return false
      const is_processing = this.f_store.files.some(x => x.processing)
      const is_uploads = this.f_store.uploads.length === 0
      return !!(this.value?.length && !is_processing && is_uploads)
    }
  },
  methods: {
    setHeight(){
      if (!this.$refs.absolute) {
        // TODO: fast fix before release. need to fix it inside v-resize and check in other places
        return
      }
      this.chat_height = `${this.$refs.absolute.offsetHeight}px`
    },
    focus() {
      if (!this.generating && !this.disabled && !this.recording) {
        this.$refs.input.focus()
      }
    },
    blur(){
      this.$refs.input.blur()
    },
    uploadFile(){
      this.$refs.uploads.uploadFile()
    },
    onPush(event){
      if (!this.can_push) return
    
      const params = {text: $utils.str.capitalizeSentences(this.value)}
      if (this.f_store.files.length) {
        params.files = this.f_store.files.map(x => x.id)
      }
      this.$emit('regenerate', params)

      this.value = ''
      this.blur()
      this.f_store = create_store(DOCUMENT.type)
    },
    onStop(){
      this.$emit('stop')
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "2fdb3eef-chat_height": (_ctx.chat_height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__